// extracted by mini-css-extract-plugin
module.exports = {"input":"Input_input__1BPgu","title":"Input_title__15fKE","text":"Input_text__1Jc2V"};